<template>
  <v-dialog :value="value" persistent max-width="532px" attach="#modal-portal">
    <v-card class="mx-auto">
      <v-toolbar dark color="primary" height="45">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn small icon color="primary" @click="closeForm"><v-icon>close</v-icon></v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-form @submit.prevent="sendUndeliveredReport" ref="form">
          <v-card>
            <v-container fluid grid-list-sm class="py-2">
              <v-text-field v-model="clientName" label="Client Name" readonly></v-text-field>
              <v-layout row wrap style="height:50px;padding-top:8px">
                <v-flex xs6>
                  <vonap-toolbar-label label="Forwards or options">
                    <kendo-dropdownlist
                      v-model="optionValue"
                      :data-source="optionDataSource"
                      :data-text-field="'forwardOptionName'"
                      :data-value-field="'forwardOptionId'"
                      :change="optionDropDownChange"
                      style="width:125px"
                    >
                    </kendo-dropdownlist>
                  </vonap-toolbar-label>
                </v-flex>
                <v-flex xs6>
                  <vonap-toolbar-label label="Undelivered Balance Message">
                    <kendo-dropdownlist
                      v-model="sendingMessageId"
                      :data-source="sendingMessageData"
                      :data-text-field="'sendingMessageName'"
                      :data-value-field="'sendingMessageId'"
                      @change="onSendingMessageIdChange"
                      style="width:88%"
                    ></kendo-dropdownlist>
                    <v-btn
                      small
                      icon
                      color="blue primary"
                      @click="toggleSendingMessageVisible"
                      style="position:absolute;width:32px;height:32px;top:-4px"
                    >
                      <v-icon>save</v-icon>
                    </v-btn>
                  </vonap-toolbar-label>
                </v-flex>
              </v-layout>
              <v-layout row wrap style="height:50px;padding-top:16px">
                <v-flex xs6>
                  <vonap-toolbar-label label="Ccy Pair">
                    <kendo-dropdownlist
                      v-model="ccyPairValue"
                      :data-source="ccyPairDataSource"
                      :data-text-field="'text'"
                      :data-value-field="'value'"
                      style="width:92px"
                    >
                    </kendo-dropdownlist>
                  </vonap-toolbar-label>
                </v-flex>
                <v-flex xs6 style="margin-top:-10px">
                  <vonap-toolbar-label label="Show Transactions Panel">
                    <v-switch v-model="showTransactionsPanel" />
                  </vonap-toolbar-label>
                </v-flex>
              </v-layout>
              <v-text-field
                v-model="sendFrom"
                type="email"
                label="From:"
                required
                @change="onSendFromChange"
                :rules="[v => !!v || 'Email is required!']"
              ></v-text-field>
              <div style="display:flex">
                <v-text-field
                  v-model="sendTo"
                  type="email"
                  label="To:"
                  required
                  :rules="[v => !!v || 'Email is required!']"
                ></v-text-field>
                <v-btn
                  small
                  icon
                  color="blue primary"
                  @click="saveEmailTo"
                  style="width:32px;height:32px"
                >
                  <v-icon>save</v-icon>
                </v-btn>
              </div>
              <v-text-field v-model="sendCc" type="email" label="CC:"></v-text-field>
              <v-text-field
                v-model="sendSubject"
                type="text"
                label="Subject:"
                :rules="[v => !!v || 'Subject is required!']"
                counter="114"
              ></v-text-field>
              <v-textarea
                v-model="sendComments"
                label="Comments"
                counter="2000"
                :rules="[v => !!v || 'Comments is required!']"
              ></v-textarea>
              <v-divider></v-divider>
              <v-card-actions>
                <v-flex xs5>
                  <vonap-toolbar-label label="Email Signature">
                    <kendo-dropdownlist
                      v-model="emailSignature"
                      :data-source="analystEmailsDataSource"
                      :data-text-field="'email'"
                      :data-value-field="'email'"
                      style="width:150px"
                    >
                    </kendo-dropdownlist>
                  </vonap-toolbar-label>
                </v-flex>
                <v-flex xs4>
                  <v-switch v-model="testMode" label="Send TEST" @change="onTestModeChange" />
                </v-flex>
                <v-spacer></v-spacer>
                <v-btn icon color="blue primary" @click="toggleUndeliveredBalancePreviewVisible">
                  <v-icon style="font-size:16px">fa fa-binoculars</v-icon>
                </v-btn>
                <v-btn type="submit" color="blue primary" :disabled="sending">
                  <v-progress-circular indeterminate v-if="sending" />
                  Send
                </v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-form>
      </v-card-text>
    </v-card>

    <change-sending-message-confirm-form
      :value="changeSendingMessageVisible"
      :client-id="formParams.clientId"
      :sending-message-name="sendingMessageName"
      :sending-message-id="sendingMessageId"
      :forward-option-id="optionValue"
      :send-subject="sendSubject"
      :send-comments="sendComments"
      @success="changeSendingMessageSuccess"
      @input="changeSendingMessageVisible = $event"
    />

    <undelivered-balance-preview
      v-model="undeliveredBalancePreviewVisible"
      :form-params="undeliveredBalancePreviewParams"
      @success="undeliveredBalancePreviewVisible = $event"
    />
  </v-dialog>
</template>
<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import notification from '@/helpers/notification'
import VonapToolbarLabel from '@/components/VonapToolbarLabel'
import ChangeSendingMessageConfirmForm from '@/components/ChangeSendingMessageConfirmForm'
import UndeliveredBalancePreview from '@/components/UndeliveredBalancePreview'

export default {
  props: {
    value: {type: Boolean},
    selectedOperations: {type: Array, default: null},
    formParams: {type: Object},
  },
  components: {
    VonapToolbarLabel,
    ChangeSendingMessageConfirmForm,
    UndeliveredBalancePreview,
  },
  computed: {
    ...mapGetters({currentUsername: 'authentication/currentUsername'}),
    title() {
      return this.formParams.title
    },
  },
  data() {
    return {
      sending: false,
      clientName: '',
      clientEmail: '',
      sendFrom: '',
      sendTo: '',
      sendCc: '',
      sendingMessageId: 0,
      sendingMessageName: 'N/A',
      sendingMessageData: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/report/ExposureReport/getSendingMessageData',
            data: () => {
              return {clientId: +this.formParams.clientId}
            },
            contentType: 'application/json',
            type: 'GET',
          },
        },
      }),
      sendSubject: '',
      sendComments: '',
      optionValue: 0,
      optionDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/report/ExposureReport/getForwardOption',
            contentType: 'application/json',
            type: 'GET',
          },
        },
      }),
      showTransactionsPanel: true,
      ccyPairValue: 1,
      ccyPairDataSource: [{text: 'All', value: 0}, {text: 'Selected', value: 1}],
      changeSendingMessageVisible: false,
      testMode: false,
      undeliveredBalancePreviewVisible: false,
      undeliveredBalancePreviewParams: {},
      emailSignature: '',
      analystEmailsDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/report/ExposureReport/getAnalystEmails',
            contentType: 'application/json',
            type: 'GET',
          },
        },
      }),
    }
  },
  methods: {
    getFormData() {
      const formData = {
        sendingListId: +this.formParams.sendingListId,
        asOfDate: this.formParams.asOfDate,
        clientId: +this.formParams.clientId,
        responsibleEmail: 'ALL',
        analystEmail: 'ALL',
        reconciledClient: this.formParams.reconciledClient,
        sendFrom: this.sendFrom,
        sendTo: this.sendTo,
        sendCc: this.sendCc,
        sendingMessageId: +this.sendingMessageId,
        sendSubject: this.sendSubject,
        sendComments: this.sendComments,
        url: location.origin,
        emailSignature: this.emailSignature,
        manualSettings: {
          optionValue: this.optionValue,
          ccyPairId: this.ccyPairValue == 1 ? this.formParams.ccyPairId : 0,
          showTransactionsPanel: this.showTransactionsPanel,
          testMode: this.testMode,
          testEmail: this.sendTo,
          operations: this.selectedOperations,
        },
      }
      return formData
    },
    async sendUndeliveredReport() {
      if (!this.$refs.form.validate()) return

      if (!this.testMode) {
        const result = await axios.post('/api/report/ExposureReport/Verify', {
          asOfDate: this.formParams.asOfDate,
          items: [{clientId: +this.formParams.clientId}],
        })
        const hasData = result.data
        if (hasData) {
          if (
            !confirm(
              'For the selected date month we found some existing entries for some Clients & Currency Pairs, do you want to continue?',
            )
          )
            return
        }
      }

      this.sending = true
      const formData = this.getFormData()
      const response = await axios
        .post('/api/report/ExposureReport/sendUndeliveredMail', formData)
        .catch(() => {
          notification('Some error', 'error')
          this.sending = false
        })

      if (response.status == 200) {
        notification('Report sent successfully')
        const result = {
          clientId: +formData.clientId,
          ccyPairId: +formData.manualSettings.ccyPairId,
          optionForwardId: +formData.manualSettings.optionValue,
          testMode: formData.manualSettings.testMode,
          status: response.data,
        }
        this.$emit('success', result)
      }

      this.closeForm()
    },
    async getClientData() {
      await this.sendingMessageData.read()
      const req = await axios
        .get('/api/report/ExposureReport/getClientData', {
          params: {
            sendingListId: +this.formParams.sendingListId,
            clientId: +this.formParams.clientId,
            optionValue: +this.optionValue,
            t: new Date().getTime(),
          },
        })
        .catch(() => notification('Error ', 'error'))
      let data = req.data
      this.clientName = data.clientName
      this.sendFrom = data.mailFrom
      this.sendTo = data.mailTo
      this.sendCc = data.mailCc
      this.clientEmail = data.email
      this.sendingMessageId = +data.messageId
      this.sendingMessageName = data.messageName
      this.sendSubject = data.subject
      this.sendComments = data.message
      this.showTransactionsPanel = data.showTransactionsPanel
      this.emailSignature = data.emailSignature
    },
    async optionDropDownChange({sender}) {
      this.optionValue = +sender.value()
      await this.getClientData()
    },
    async onSendingMessageIdChange({sender}) {
      this.sendingMessageId = +sender.value()
      this.sendingMessageName = sender.text()
      if (this.sendingMessageId == 0) {
        this.sendSubject = ''
        this.sendComments = ''
        return
      }

      const req = await axios
        .get('/api/report/ExposureReport/getSendingMessage', {
          params: {
            sendingMessageId: +this.sendingMessageId,
            t: new Date().getTime(),
          },
        })
        .catch(() => notification('Error ', 'error'))
      let data = req.data
      this.sendSubject = data.subject
      this.sendComments = data.message
    },
    async onSendFromChange() {
      this.sendCc = this.testMode ? '' : this.mailCc
    },
    toggleSendingMessageVisible() {
      this.changeSendingMessageVisible = !this.changeSendingMessageVisible
    },
    toggleUndeliveredBalancePreviewVisible() {
      this.undeliveredBalancePreviewParams = {
        sendingListId: +this.formParams.sendingListId,
        asOfDate: this.formParams.asOfDate,
        clientId: +this.formParams.clientId,
        responsibleEmail: 'ALL',
        analystEmail: 'ALL',
        reconciledClient: this.formParams.reconciledClient,
        sendFrom: this.sendFrom,
        sendTo: this.sendTo,
        sendCc: this.sendCc,
        sendingMessageId: +this.sendingMessageId,
        sendSubject: this.sendSubject,
        sendComments: this.sendComments,
        url: location.origin,
        emailSignature: this.emailSignature,
        manualSettings: {
          optionValue: this.optionValue,
          ccyPairId: this.ccyPairValue == 1 ? this.formParams.ccyPairId : 0,
          showTransactionsPanel: this.showTransactionsPanel,
          testMode: this.testMode,
          testEmail: this.sendTo,
          operations: this.selectedOperations,
        },
      }

      this.undeliveredBalancePreviewVisible = !this.undeliveredBalancePreviewVisible
    },
    async changeSendingMessageSuccess() {
      await this.getClientData()
      this.toggleSendingMessageVisible()
    },
    async saveEmailTo() {
      if (!this.$refs.form.validate()) return

      const formData = this.getFormData()
      const response = await axios
        .post('/api/report/ExposureReport/saveUndeliveredMail', formData)
        .catch(() => {
          notification('Some error', 'error')
        })

      if (response.status == 200) {
        notification('Email saved successfully!')
        const result = {
          clientId: +formData.clientId,
          ccyPairId: +formData.manualSettings.ccyPairId,
          optionForwardId: +formData.manualSettings.optionValue,
          testMode: true,
        }
        this.$emit('success', result)
      }
    },
    onTestModeChange() {
      if (this.testMode) {
        this.sendTo = this.currentUsername
        this.sendCc = ''
      } else {
        this.sendTo = this.clientEmail
        this.sendCc = this.mailCc
      }
    },
    closeForm() {
      this.$emit('input', false)
    },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.sendingMessageId = 0
        this.sendingMessageName = 'N/A'
        this.sendCc = ''
        this.sendSubject = ''
        this.sendComments = ''
        this.sending = false
        this.optionValue = this.formParams.optionForwardId
        this.showTransactionsPanel = true
        this.ccyPairValue = 1
        this.testMode = false
        this.getClientData()
      }
    },
  },
}
</script>
